export default __webpack_public_path__ + "static/media/spw2.6d5f292f.PNG";